<template>
  <el-input-number :value="value" :min="0" :step="1" size="mini" @change="$emit('change', $event)" />
</template>

<script>
export default {
  name: "SortInput",
  props: {
    value: { type: Number, default: 0 }
  }
};
</script>
